<div class="account-settings-language-wrapper">
  @for (language of languages; track language.languageCode) {
    <div
      class="account-settings-language-item"
      (click)="onLanguagePreferenceSelection(language)"
      (keydown.enter)="onLanguagePreferenceSelection(language)"
      role="button"
      tabindex="0"
      [attr.aria-label]="language.friendlyName"
    >
      <span class="ods-typography-body-m-bold">{{ language.friendlyName }}</span>
      <mat-icon *ngIf="selectedLanguageCode === language.languageCode">check</mat-icon>
    </div>
  }
</div>
